import { DataTable } from "@/components/data-table/data-table";
import { columns } from "@/components/knowledge-base/columns";
import { Filters } from "@/components/knowledge-base/filters";
import { useTriggerKnowledgeBase } from "@/lib/api/triggers-knowledge-base";
import { useDataTable } from "@/lib/hooks/use-data-table";
import { createFileRoute, useRouter, useSearch } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";
import { PlusIcon } from "lucide-react";

export const Route = createFileRoute("/_authenticated/knowledge-base/")({
  component: KnowledgeBase,
});

function KnowledgeBase() {
  const router = useRouter();
  const { page, search, per_page } = useSearch({
    strict: false,
  }) as Record<string, string>;

  const currentPage = parseInt(page || "1", 10);
  const pageSize = parseInt(per_page || "20", 10);

  const { data, isPending } = useTriggerKnowledgeBase(
    currentPage,
    pageSize,
    search,
  );

  const { table } = useDataTable({
    columns,
    data: data?.triggers || [],
    defaultPerPage: pageSize,
    pageCount: -1, // Always use -1 for infinite pagination
    filterFields: [],
  });

  const handlePageChange = (newPageIndex: number) => {
    const newPage = newPageIndex + 1;
    router.navigate({
      to: router.state.location.pathname,
      search: (prev: any) => ({
        ...prev,
        page: newPage,
      }),
    });
  };

  const handlePageSizeChange = (newPageSize: number) => {
    router.navigate({
      to: router.state.location.pathname,
      search: (prev: any) => ({
        ...prev,
        page: 1, // Reset to first page when changing page size
        per_page: newPageSize,
      }),
    });
  };

  return (
    <div className="m-6 pb-16">
      <div className="mb-6 flex items-center justify-between">
        <h1 className="text-2xl font-bold">Knowledge Base</h1>
        <Button onClick={() => router.navigate({ to: "/knowledge-base/new" })}>
          <PlusIcon className="mr-2 h-4 w-4" />
          Create New
        </Button>
      </div>

      <DataTable
        table={table}
        getCanNextPage={() => {
          return data?.hasMore || false;
        }}
        getCanPreviousPage={() => {
          return currentPage > 1;
        }}
        isPending={isPending}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
      >
        <Filters />
      </DataTable>
    </div>
  );
}
